import moment from 'moment';
import {FieldUtility} from '../GridWidget/GridWidgetUtility';
import {wdiCore} from '../WdiControls';

/**表格组件，一些通用的数据格式化方式 */
export const TableColumnRanderFormats = {
  /**显示到分 yyyy-MM-dd hh:mm*/
  ToMinutes: function (value: any, record: any, index: number) {
    if (!value) {
      return value;
    }
    return moment(value).format('YYYY-MM-DD HH:mm');// DateTime(value, 'yyyy-MM-dd hh:mm')
  },
  /**时间显示 yyyy-MM-dd */
  ToDate: function (value: any, record: any, index: number) {
    if (!value) {
      return value;
    }
    return moment(value).format('YYYY-MM-DD');// DateTime(value, 'yyyy-MM-dd')
  },
  sumAggr: function (key: string, digits?: number) {
    return (col: any, source: any, aggrProps: any) => {
      if (source) {
        let sum = 0;
        source.forEach((item: any) => {
          const amount = Number(item[key]);
          if (!Number.isNaN(amount)) {
            sum += amount;
          }
        })
        if (digits === undefined || digits < 0) {
          return String(sum);
        }
        return wdiCore.Number.AmountToString(sum, digits);
      }
      return '';
    }
  },
  /**
   * 比例求和
   * @param numeratorKey 分子列
   * @param denominatorKey 分母列
   * @param digits 百分比后小数位，默认2位
   */
  rateSumAggr: function (numeratorKey: string, denominatorKey: string, digits?: number) {
    return (col: any, source: any, aggrProps: any) => {
      if (source) {
        let sumNumerator = 0,
          sumDenominator = 0;
        source.forEach((item: any) => {
          const numerator = Number(item[numeratorKey]);
          const denominator = Number(item[denominatorKey]);
          if (!Number.isNaN(numerator)) {
            sumNumerator += numerator;
          }
          if (!Number.isNaN(denominator)) {
            sumDenominator += denominator;
          }
        });
        return wdiCore.Number.RateToString(sumNumerator / sumDenominator, digits ?? 2);
      }
      return '';
    }
  },
};

export const TableFieldFormal: Record<string, (_t: any, record: any, index?: any) => any> = {
  boId: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.boName)) {
      return record.boName;
    }
    return '';
  },
  bohqId: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.bohqName)) {
      return record.bohqName;
    }
    return '';
  },
  ecId: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.ecName)) {
      return record.ecName;
    }
    return '';
  },
  ecMktId: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.ecMktName)) {
      return record.ecMktName;
    }
    return '';
  },
  shopId: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.shopCode, record.shopName);
    }
    return '';
  },
  productId: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.productCode, record.productName);
    }
    return '';
  },
  soldToCode: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.soldToCode, record.soldToName);
    }
    return '';
  },
  shipToCode: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.shipToCode, record.shipToName);
    }
    return '';
  },
  shipToCodes: (_t: any, record: any, index: any) => {
    if (record) {
      return record.shipToNames;
    }
    return '';
  },
  supplierId: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.supplierCode, record.supplierName);
    }
    return '';
  },
  modifiedUserId: (_t: any, record: any, index: any) => {
    if (record) {
      return record.modifiedUserName;
    }
    return '';
  },
  paymentMethodId: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.paymentMethodName)) {
      return record.paymentMethodName;
    }
    return '';
  },
  displayTypeId: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.displayTypeName)) {
      return record.displayTypeName;
    }
    return '';
  },
  displayTypeIds: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.displayTypeNames)) {
      return record.displayTypeNames;
    }
    return '';
  },
  displayLocationId: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.displayLocationName)) {
      return record.displayLocationName;
    }
    return '';
  },
  revenueType: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.revenueTypeName)) {
      return record.revenueTypeName;
    }
    return '';
  },
  custSysCode: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.custSysCode, record.custSysName);
    }
    return '';
  },
  payToCode: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.payToCode, record.payToName);
    }
    return '';
  },
  productBuyIds: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.productBuyNames)) {
      return record.productBuyNames;
    }
    return '';
  },
  productFreeIds: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.productFreeNames)) {
      return record.productFreeNames;
    }
    return '';
  },
  syncStatus: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.syncStatusName)) {
      return record.syncStatusName;
    }
    return record.syncStatus;
  },
  syncStatus1: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.syncStatus1Name)) {
      return record.syncStatus1Name;
    }
    return record.syncStatus1;
  },
  allocatedBoIds: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.allocatedBoNames)) {
      return record.allocatedBoNames;
    }
    return '';
  },
  productPolicyId: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.policyCode, record.policyName);
    }
    return '';
  },
  tradeTypeCode: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.tradeTypeCode, record.tradeTypeName);
    }
    return '';
  },
  assignProductId: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.assignProductCode, record.assignProductName);
    }
    return '';
  },
  startDate: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Date.Join(record.startDate, record.endDate);
    }
    return '';
  },
  rebateStartDate: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Date.Join(record.rebateStartDate, record.rebateEndDate);
    }
    return '';
  },
  generateType: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.generateTypeName)) {
      return record.generateTypeName;
    }
    return '';
  },
  quantitySellinRate: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Number.RateToString(
        record.quantitySellinActual / record.quantitySellinForecast,
      );
    }
    return '';
  },
  revenueSellinRate: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Number.RateToString(record.revenueSellinActual / record.revenueSellinForecast);
    }
    return '';
  },
  quantitySelloutRate: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Number.RateToString(
        record.quantitySelloutActual / record.quantitySelloutForecast,
      );
    }
    return '';
  },
  revenueSelloutRate: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Number.RateToString(
        record.revenueSelloutActual / record.revenueSelloutForecast,
      );
    }
    return '';
  },
  quantitySelloutRate2: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Number.RateToString(
        record.quantitySelloutActual2 / record.quantitySelloutForecast2,
      );
    }
    return '';
  },
  quantitySelloutRate3: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Number.RateToString(
        record.quantitySelloutActual3 / record.quantitySelloutForecast3,
      );
    }
    return '';
  },
  quantitySelloutRate4: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Number.RateToString(
        record.quantitySelloutActual4 / record.quantitySelloutForecast4,
      );
    }
    return '';
  },
  quantitySelloutRate5: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Number.RateToString(
        record.quantitySelloutActual5 / record.quantitySelloutForecast5,
      );
    }
    return '';
  },
  quantityPosRate: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Number.RateToString(record.quantityPosActual / record.quantityPosForecast);
    }
    return '';
  },
  revenuePosRate: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.Number.RateToString(record.revenuePosActual / record.revenuePosForecast);
    }
    return '';
  },
  discountType: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.discountTypeName)) {
      return record.discountTypeName;
    }
    return '';
  },
  productSpecId: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.productSpecName)) {
      return record.productSpecName;
    }
    return '';
  },
  productIdsReach: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.productNamesReach)) {
      return record.productNamesReach;
    }
    return '';
  },
  productIdsRebate: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.productNamesRebate)) {
      return record.productNamesRebate;
    }
    return '';
  },
  createdUserId: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.createdUserName)) {
      return record.createdUserName;
    }
    return '';
  },
  deliveredOperatorId: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.deliveredOperator)) {
      return record.deliveredOperator;
    }
    return '';
  },
  companyCode: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.companyCode, record.companyName);
    }
    return '';
  },
  bankAccountId: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.bankAccountNo, record.bankAccountName);
    }
    return '';
  },
  oaFormNo: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.oaFormNo, record.oaFormName);
    }
    return '';
  },
  brandCode: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.brandCode, record.brandName);
    }
    return '';
  },
  salesOrgCode: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.salesOrgCode, record.salesOrgName);
    }
    return '';
  },
  boIds: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.boIds)) {
      return record.boNames;
    }
    return '';
  },
  custTypeId: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.custTypeId)) {
      return wdiCore.String.CodeOrName(record.custTypeCode, record.custTypeName);
    }
    return '';
  },
  soldToRealCodes: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.soldToRealCodes)) {
      return record.soldToRealNames;
    }
    return '';
  },
  productFgIds: (_t: any, record: any, index: any) => {
    if (record && !wdiCore.String.IsNullOrEmpty(record.productFgNames)) {
      return record.productFgNames;
    }
    return record.productFgIds;
  },
  ecId1: (value: any, record: any, index: any) => {
    if (!wdiCore.String.IsNullOrEmpty(record?.ecName1)) {
      return record.ecName1;
    }
    return value;
  },
  ecId2: (value: any, record: any, index: any) => {
    if (!wdiCore.String.IsNullOrEmpty(record?.ecName2)) {
      return record.ecName2;
    }
    return value;
  },
  boId1: (value: any, record: any, index: any) => {
    if (!wdiCore.String.IsNullOrEmpty(record?.boName1)) {
      return record.boName1;
    }
    return value;
  },
  boId2: (value: any, record: any, index: any) => {
    if (!wdiCore.String.IsNullOrEmpty(record?.boName2)) {
      return record.boName2;
    }
    return value;
  },
  boId3: (value: any, record: any, index: any) => {
    if (!wdiCore.String.IsNullOrEmpty(record?.boName3)) {
      return record.boName3;
    }
    return value;
  },
  activitySubjectId: (value: any, record: any, index: any) => {
    if (!wdiCore.String.IsNullOrEmpty(record?.activitySubjectName)) {
      return record.activitySubjectName;
    }
    return value;
  },
  uomCode: (value: any, record: any, index: any) => {
    if (!wdiCore.String.IsNullOrEmpty(record?.uomName)) {
      return record.uomName;
    }
    return value;
  },
  payToTypeId: (value: any, record: any, index: any) => {
    return record.payToTypeName ?? ''
  },
  payToUserId: (value: any, record: any, index: any) => {
    return wdiCore.String.GenerateLabelDescription(
      wdiCore.String.CodeOrName(record.payToUserNo, record.payToUserName),
      record.payToUserTitle
    );
  },
  custSysAddCode: (value: any, record: any, index: any) => {
    if (!wdiCore.String.IsNullOrEmpty(record?.custSysAddName)) {
      return record.custSysAddName;
    }
    return value;
  },
  brandId: (_t: any, record: any, index: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.brandCode, record.brandName);
    }
    return '';
  },
};

export const initFieldDisplayFormater = function (allFields: any) {
  for (const key in TableFieldFormal) {
    if (allFields[key]) {
      allFields[key].getDisplayFormater = TableFieldFormal[key];
    }
  }
};

const TableExpandedFormal = (key: string, record: any, fieldObject: any) => {
  let result;
  if (wdiCore.String.IsNullOrEmpty(result)) {
    if (!wdiCore.Object.IsNullOrUndefined(fieldObject.getDisplayFormater)) {
      result = fieldObject.getDisplayFormater(record[key], record);
    } else {
      for (const field in TableFieldFormal) {
        if (key == field) {
          result = TableFieldFormal[key]('', record);
        }
      }
    }
  }
  if (wdiCore.String.IsNullOrEmpty(result)) {
    const fieldCellFunc = FieldUtility[fieldObject.type];
    if (!wdiCore.Object.IsNullOrUndefined(fieldCellFunc)) {
      result = fieldCellFunc(fieldObject)(record[key]);
    } else {
      result = record[key];
    }
  }
  return result || "";
};

const getExpandedDisplayColumns = function (viewFieldNames: any, columnStates: any, record: any, initRowFieldConfigs?: (record: any) => string[]) {
  const leftFields: string[] = [];
  viewFieldNames.forEach((key: string) => {
    if (columnStates.findIndex((item: any) => (item.dataIndex == key)) < 0) {
      leftFields.push(key);
    }
  })

  const resultFields: string[] = [];
  if (initRowFieldConfigs) {
    const rowEcFieldConfigs = initRowFieldConfigs(record);
    leftFields.forEach((key: string) => {
      if (rowEcFieldConfigs.includes(key)) {
        resultFields.push(key);
      }
    })
  }
  const sortFeilds: string[] = [];
  viewFieldNames.forEach((key: string) => {
    if (resultFields.includes(key)) {
      sortFeilds.push(key);
    }
  })
  return sortFeilds;
};

export const initExpandedDisplayFormater = function (pageGridSettings: any, record: any, initRowFieldConfigs?: (record: any) => string[]) {
  const viewFieldNames = pageGridSettings.formSchema.viewFieldNames;
  const columnStates = pageGridSettings.columnStates;
  const allFields = pageGridSettings.formSchema.allFields;
  const generalFields = getExpandedDisplayColumns(viewFieldNames, columnStates, record, initRowFieldConfigs);
  return (
    <>
      {
        generalFields.map((key: string) =>
          <span key={key}>
            {allFields[key].displayName}：
            <span style={{color: '#808080'}}>{TableExpandedFormal(key, record, allFields[key]) || "(无)"}；   </span>
          </span>
        )
      }
    </>
  )
};
